import React from 'react';
import PropTypes from 'prop-types';

const TableHeader = ({ keys, data }) => {
  return (
    <thead className="responsive-table__thead">
      <tr>
        {keys.map(key => (
          <th data-table-header={key}>{data[key]}</th>
        ))}
      </tr>
    </thead>
  );
};

TableHeader.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.objectOf(PropTypes.string).isRequired
};

export default TableHeader;
